var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Trans } from '@lucidlink/uicore';
export const CloseDrawerButton = ({ closeDrawer, disabled, }) => {
    return (_jsx(Button, { "data-testid": "guest-link-close", disabled: disabled, kind: "secondary", onClick: closeDrawer, size: "big", children: _jsx(Trans, { children: "Close" }) }));
};
_react_refresh_temp_1 = CloseDrawerButton;
$RefreshReg$(_react_refresh_temp_1, "CloseDrawerButton");
